// extracted by mini-css-extract-plugin
module.exports = {"workers":"WorkersList_workers__14anW","workersList":"WorkersList_workersList__11cNa","worker":"WorkersList_worker__25-l7","green":"WorkersList_green__1l25K"};